<template>
  <div>
    <v-row class="mt-6">
      <v-col :cols="isMobile ? 12 : 3">
        <div class="mx-4">
          <v-card-title :style="getThemeStyle">
            Set Defualts For Capturing
          </v-card-title>
          <v-card dark>
            <vAutoComplete
              class="mx-4"
              text="name"
              bgColor="warning"
              :items="categories"
              value="id"
              label="Select Default Category"
              @item-selected="setDefaultCategory"
            >
            </vAutoComplete>

            <vInputField
              class="mx-4"
              :defaultValue="0"
              label="Default Amount"
              type="text"
              @input-updated="setDefaultAmount"
            >
            </vInputField>

            <DatePickerWithMenu
              :default="defaultDate"
              label="Default Date"
              @date-selected="setDefaultDate"
            >
            </DatePickerWithMenu>
          </v-card>
        </div>
      </v-col>
      <v-col :cols="isMobile ? 12 : 9">
        <div class="mx-4">
          <v-card-title :style="getThemeStyle">
            Set Defualts For Capturing
          </v-card-title>

          <v-card color="#616161">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Date
                    </th>
                    <th class="text-left">
                      SID
                    </th>
                    <th class="text-left">Amount ({{ getCurrency }})</th>
                    <th class="text-left">
                      Category
                    </th>
                    <th class="text-left">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in rows" :key="item.name">
                    <td>
                      <v-text-field
                        v-model="item.date"
                        @blur="saveRowToDataBase(item)"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-autocomplete
                        :items="students"
                        v-model="item.sid"
                        @change="saveRowToDataBase(item)"
                      >
                      </v-autocomplete>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.amount"
                        @blur="saveRowToDataBase(item)"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-autocomplete
                        :items="categories"
                        v-model="item.categoryID"
                        item-text="name"
                        item-value="id"
                        @change="saveRowToDataBase(item)"
                      >
                      </v-autocomplete>
                    </td>
                    <td>
                      <v-btn
                        v-if="item.id"
                        fab
                        rounded
                        color="red"
                        dark
                        @click="deleteSelectedRow(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import students from "@/plugins/students";
import finance from "@/plugins/finance";
// import vCardContainer from "@/components/Legos/vCardContainer.vue";
import vAutoComplete from "@/components/Legos/vAutoComplete.vue";
import vInputField from "@/components/Legos/vInputField.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import helpers from "@/plugins/helpers";

export default {
  components: {
    vAutoComplete,
    vInputField,
    DatePickerWithMenu,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  async mounted() {
    this.generateRowsArrays();
    this.students = students.formatStudentsForAutocomplete(
      await students.getStudents()
    );
    this.getAllIncomeCategories();
  },
  data: () => ({
    title: "Bulk Payments Capture",
    rows: [],
    students: [],
    categories: [],
    defaultDate: new Date().toISOString().substr(0, 10),
  }),
  methods: {
    setDefaultCategory(defaultCategoryID) {
      this.rows.forEach((row) => {
        row.categoryID = defaultCategoryID;
      });
    },
    setDefaultAmount(defaultAmount) {
      defaultAmount = finance.stripCurrency(defaultAmount);
      if (isNaN(defaultAmount)) {
        return false;
      }
      this.rows.forEach((row) => {
        row.amount = defaultAmount;
      });
    },
    setDefaultDate(defaultDate) {
      this.rows.forEach((row) => {
        row.date = defaultDate;
      });
    },
    generateRowsArrays() {
      const rows = [];
      for (let i = 0; i < 100; i++) {
        rows.push({
          id: null,
          date: this.defaultDate,
          sid: null,
          amount: 0,
          categoryID: null,
        });
      }
      this.rows = rows;
    },
    saveRowToDataBase(row) {
      if (
        row.sid &&
        row.amount &&
        row.amount != "0" &&
        row.date &&
        row.categoryID
      ) {
        axios
          .postDataWithToken("/auth/save-bulk-income", row, this.getAccessToken)
          .then((paymentObj) => {
            if (paymentObj && paymentObj.id) {
              row.id = paymentObj.id;
            }
            this.$toast.success("Payment successfully saved!", {
              duration: 3000,
            });
          });
      }
    },
    deleteSelectedRow(row) {
      helpers.deleteMultipleRows("incomes", [row.id]);
      this.rows.splice(this.rows.indexOf(row), 1);
      this.$toast.success("Payment successfully deleted!", {
        duration: 3000,
      });
    },
    async getAllIncomeCategories() {
      this.categories = await finance.getAllIncomeCategories();
    },
  },
};
</script>

<style></style>
